var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAppointmentSideMenuIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 21,
  fill: "none",
  viewBox: "0 0 21 21",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#49475A",
  strokeWidth: 1.3,
  d: "M17.063 8.313v-.3c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.875c-.428-.218-.988-.218-2.108-.218H7.138c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.875.875c-.218.427-.218.987-.218 2.107v.3m13.126 0v5.55c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218H7.138c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.875-.874c-.218-.427-.218-.987-.218-2.107v-5.55m13.126 0H3.938"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#49475A",
  strokeLinecap: "round",
  strokeWidth: 1.3,
  d: "M7.438 3.063v3.5m6.125-3.5v3.5M10.5 14.875V10.5M12.688 12.688H8.311"
})));
export { SvgAppointmentSideMenuIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/appointment-side-menu-icon.svg";